import React, { Component } from "react";
import styled from "styled-components";
import ReviewAwardDialog from "./ReviewAwardDialog";
import AcceptAwardDialog from "./AcceptAwardDialog";
import { addFlashMessageOfType } from 'redux-flash-messages'
import { bindActionCreators } from "redux";
import { actions as employeeActions } from "../../../actions/employee";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { actions as maintenanceActions } from '../../../actions/maintenance'
import { history } from '../../../store'

const Container = styled.div``;

export class AcceptAwardWizard extends Component {
  constructor(props) {
    super(props);

    this.state = AcceptAwardWizard.getInitialState(props)
  }

  static getInitialState = (props) => {
    return {
      visible: props.visible,
      reviewAwardDialogVisible: true,
      acceptAwardDialogVisible: false,
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.visible !== prevState.visible) {
      return AcceptAwardWizard.getInitialState(nextProps);
    }
    return null;
  }

  viewDocumentationClick = (award, callback) => {
    // Hide the ReviewAward dialog.
    this.setState(
      {
        reviewAwardDialogVisible: false
      },
      // Show the AcceptAward dialog.
      () => {
        this.setState({
          acceptAwardDialogVisible: true
        })
      }
    )
  }

  onBackButton = () => {
    // Hide the AcceptAward dialog.
    this.setState(
      {
        acceptAwardDialogVisible: false
      },
      // Show the ReviewAward dialog.
      () => {
        this.setState({
          reviewAwardDialogVisible: true
        })
      }
    )
  }

  onAcceptAwardAction = (award, callback) => {

    this.props.actions.maintenance.checkMaintenaceStatus().then(isLive => {
      if(isLive) {
        this.props.actions.employee.acceptAward(award.id).then(_ => {
          // Hide the AcceptAward dialog.
          this.setState(
            {
              acceptAwardDialogVisible: false
            },
            () => {
              this.props.onWizardClosed()
              // Show the flash message.
              addFlashMessageOfType("SUCCESS", 5000, this.props.t('UnacceptedStockAwards.AcceptedAwardMessage'), null, null);
            }
          )
        }).catch(_ => {
          this.setState(
            {
              acceptAwardDialogVisible: false
            },
            () => {
              this.props.onWizardClosed()
              // Show the flash message.
              addFlashMessageOfType("ERROR", 5000, this.props.t('UnacceptedStockAwards.FailAcceptedAwardMessage'), null, null);
            }
          )
        })
      } else {
        history.push("/maintenance", {})
      }
    })
  }

  render() {
    if (this.state.visible) {
      const data = {
        broker: this.props.broker,
        award: this.props.award
      };
      return (
        <Container>
          <ReviewAwardDialog
            visible={this.state.reviewAwardDialogVisible}
            data={data}
            onCloseDialog={this.props.onWizardClosed}
            onReviewDocumentAward={this.viewDocumentationClick}
          />
          <AcceptAwardDialog
            visible={this.state.acceptAwardDialogVisible}
            data={data}
            onCloseDialog={this.props.onWizardClosed}
            onAcceptAward={this.onAcceptAwardAction}
            onBackButton={this.onBackButton}
          />
        </Container>
      );
    }

    return null
  }
}

const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch),
    maintenance: bindActionCreators(maintenanceActions, dispatch),
  }
});

export default connect(null, mapDispatchToProps)(
  withTranslation("translations")(AcceptAwardWizard)
);
